<template>
  <div class="user_container">
    <div class="driverContainer">
      <!-- 用车申请 审批中列表 -->
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" offset="50" @load="onLoad">
        <div class="itemContent">
          <div class="driverItems" v-for="(item, index) in list" :key="index" @click="useCarDetail(item)">
            <div class="itemsContent">
              <div class="itemsUser">
                <div class="userTitle">{{ item.applyTitle }}</div>
                <div class="tabsList">
                  <div class="tabBtn colorYellow">
                    <span class="btn">{{
                      useTypeList[item.useType - 1]
                    }}</span>
                  </div>
                  <div class="tabBtn colorBlue">
                    <span class="btn">审批中</span>
                  </div>
                </div>
              </div>
              <div class="itemsPlace">
                <div class="allotPlaceItems">
                  <div class="place">{{ item.airportName }}</div>
                </div>
                <div class="line">
                  <img src="@/assets/car/placeArrows.png" alt="" />
                </div>
                <div class="allotPlaceItems1">
                  <div class="place" v-for="(i, int) in item.addressInfoList" :key="int">{{ i.useLocation }}</div>
                </div>
              </div>
              <div class="itemsInfo">
                <div class="info">人数：{{ item.useNumber }}</div>
              </div>
              <div class="itemsInfo">
                <div class="info">
                  用车时间：<span style="font-size: 13px;">{{ item.useSaterTime + " - " + item.useEndTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/car";
import moment from "moment";
import "@/assets/car/icon/iconfont.css";
export default {
  name: "examine",
  props: {
    active: {
      default:null,
    }
  },
  components: {},
  data() {
    return {
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      list: [],
      useTypeList: ["客户接待", "接机", '送机', "供应商考察", "其他"],
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    //初始化获取列表
    onLoad() {
      this.queryUseCarAllot();

    },
    //获取用车申请审批中列表
    queryUseCarAllot() {
      const json = {
        applyState: 1,
        page: this.page,
        pageSize: this.pageSize,
        zoneId: localStorage.getItem('cityId')
      };
      apis.queryUseCarAllotList(json).then(res => {
        this.totalAll = res.data.total;
        this.finished = false;
        // 判断分页，下滑刷新数据
        if (this.page === 1) {
          this.list = res.data.list;
        } else {
          this.list = this.list.concat(res.data.list);
        }
        if (this.list.length < this.totalAll) {
          console.log(111111111111);
          this.page = this.page + 1;
        } else {
          this.finished = true;
        }
        this.loading = false;

        this.list = this.list.map(item => {
          item.checked = false;
          item.useSaterTime = moment(item.useSaterTime).format(
            "YYYY-MM-DD  HH:mm"
          );
          item.useEndTime = moment(item.useEndTime).format("YYYY-MM-DD HH:mm");
          return item;
        });
      });
    },
    //跳转用车申请详情
    useCarDetail(item) {
      localStorage.setItem('active',this.active)
      this.$router.push(
        `/car/facility/alreadyAllotDetail?applyNumber=${item.applyNumber}`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .driverContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .driverContainer {
    width: 276px * $zoom;
  }
}

.user_container {
  font-size: 16px * $zoom;

  .driverContainer {
    padding: 30px;
    height: calc(100vh - 110px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .driverItems {
      margin-bottom: 20px;
      background-color: #fff;

      .itemsHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .headerContent {
          font-size: 27px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
          display: flex;
          align-items: center;

          .userName {
            width: 53px;
            height: 53px;
            border-radius: 50%;
            margin-right: 11px;
          }

          .car {
            width: 36px;
            height: 27px;
            margin-right: 11px;
          }

          .carTitle {
            font-weight: bold;
          }
        }
      }

      .itemsContent {
        padding: 0 20px 25px 20px;

        .itemsUser {
          display: flex;

          margin: 0 0 4vh 0;

          .userTitle {
            font-size: 27px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: #282b32;
            margin-right: 20px;
            padding-top: 36px;
          }

          .tabsList {
            display: flex;

            .tabBtn {
              min-width: 106px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border-radius: 6px;
              padding: 0 10px;
              margin-top: 36px;
              margin-right: 20px;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .colorYellow {
              background-color: #fff3e8;
              color: #ff8e20;
            }

            .colorBlue {
              background-color: #e9f1fc;
              color: #2c76e3;
            }

            .colorGreen {
              background-color: #edf5f2;
              color: #4ea27c;
            }
          }
        }

        .itemsPlace {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 24px;

          .line {
            width: 50px;
            height: 7px;
            display: flex;
            align-items: center;
            margin: 0 18px;

            img {
              width: 50px;
              height: 7px;
            }
          }

          .allotPlaceItems {
            min-width: 23%;
            max-width: 29%;

            .place {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 23px;
              // font-weight: bold;
              color: #4ea27c;
            }
          }

          .allotPlaceItems1 {
            min-width: 23%;
            max-width: 87%;

            .place {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 23px;
              // font-weight: bold;
              color: #4ea27c;
            }
          }
        }

        .itemsInfo {
          margin: 2vh 0;
          font-size: 24px;
          color: #a3a2a0;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
        }

        .splitLine {
          width: 100%;
          height: 1px;
          border: 1px solid #f1f1f1;
          margin: 37px 0;
        }

        .itemsBtn {
          text-align: right;

          ::v-deep(.van-button--small) {
            border-radius: 10px;
            height: 50px;
            padding: 0 30px;
            background-color: #4ea27c;
            font-size: 27px;
            color: #fff;
          }
        }
      }
    }
  }

  ::v-deep(.van-form) {
    .van-cell {
      border: 1px solid #cccccc;
      margin-bottom: 20px;
    }
  }
}
</style>
